// PesaSpoon — scripts propios (vanilla, sin librerías externas)
document.addEventListener('DOMContentLoaded', function () {
  initReveal();
  initContador();
  initGaleriaProducto();
  initSelectorVariantes();
  initFlotante();
  initComparador();
  initBarraFija();
  initLightbox();
  initPacksPortada();
});

function initPacksPortada() {
  document.querySelectorAll('[data-ps-hero-compra]').forEach(function (bloque) {
    var packs = bloque.querySelectorAll('.ps-hero-pack');
    if (!packs.length) return;
    var precio = bloque.querySelector('[data-ps-hero-precio]');
    var antes = bloque.querySelector('[data-ps-hero-antes]');
    var descuento = bloque.querySelector('[data-ps-hero-descuento]');
    var pill = bloque.querySelector('[data-ps-hero-pill]');
    var boton = bloque.querySelector('[data-ps-hero-boton]');

    packs.forEach(function (pack) {
      pack.addEventListener('click', function () {
        packs.forEach(function (p) { p.classList.remove('is-activa'); p.setAttribute('aria-checked', 'false'); });
        pack.classList.add('is-activa');
        pack.setAttribute('aria-checked', 'true');
        var textoAntes = pack.getAttribute('data-ps-antes');
        if (precio) precio.textContent = pack.getAttribute('data-ps-precio');
        if (antes) { antes.textContent = textoAntes; antes.hidden = !textoAntes; }
        if (descuento) { descuento.textContent = pack.getAttribute('data-ps-descuento'); descuento.hidden = !textoAntes; }
        if (pill) pill.hidden = !textoAntes;
        if (boton) boton.href = pack.getAttribute('data-ps-url');
      });
    });
  });
}

function initLightbox() {
  document.querySelectorAll('[data-ps-lightbox]').forEach(function (dialogo) {
    var seccion = dialogo.closest('section') || document;
    var img = dialogo.querySelector('.ps-lightbox-img');
    if (!img || typeof dialogo.showModal !== 'function') return;

    seccion.querySelectorAll('[data-ps-foto-grande]').forEach(function (boton) {
      boton.addEventListener('click', function () {
        img.src = boton.getAttribute('data-ps-foto-grande');
        img.alt = boton.getAttribute('data-ps-foto-alt') || '';
        dialogo.showModal();
      });
    });

    dialogo.querySelector('[data-ps-lightbox-cerrar]').addEventListener('click', function () {
      dialogo.close();
    });
    // Clic fuera de la foto (sobre el fondo oscuro) también cierra.
    dialogo.addEventListener('click', function (evento) {
      if (evento.target === dialogo) dialogo.close();
    });
  });
}

function initGaleriaProducto() {
  var miniaturas = document.querySelectorAll('.ps-prod-miniatura');
  var imagenes = document.querySelectorAll('.ps-prod-imagen');
  if (!miniaturas.length || !imagenes.length) return;
  miniaturas.forEach(function (min) {
    min.addEventListener('click', function () {
      var indice = min.getAttribute('data-ps-miniatura-index');
      miniaturas.forEach(function (m) { m.classList.remove('is-activa'); });
      min.classList.add('is-activa');
      var mostrar = function () {
        imagenes.forEach(function (img) {
          img.classList.toggle('is-activa', img.getAttribute('data-ps-imagen-index') === indice);
        });
      };
      // Si la foto aún no está decodificada, se espera a que lo esté para no dejar un hueco.
      var destino = Array.prototype.find.call(imagenes, function (img) {
        return img.getAttribute('data-ps-imagen-index') === indice;
      });
      if (destino && destino.decode && !destino.complete) {
        destino.decode().then(mostrar, mostrar);
      } else {
        mostrar();
      }
    });
  });
}

function formatearPrecio(centavos, moneda) {
  try {
    var idioma = document.documentElement.lang || 'es';
    return new Intl.NumberFormat(idioma, { style: 'currency', currency: moneda }).format(centavos / 100);
  } catch (e) {
    return (centavos / 100).toFixed(2) + ' ' + moneda;
  }
}

function initSelectorVariantes() {
  var form = document.getElementById('ps-form-producto');
  if (!form) return;
  var jsonEl = document.getElementById('ps-variantes-json');
  if (!jsonEl) return;

  var variantes;
  try {
    variantes = JSON.parse(jsonEl.textContent);
  } catch (e) {
    return;
  }

  var grupos = form.querySelectorAll('.ps-prod-opcion-valores');
  var inputId = document.getElementById('ps-variante-id');
  var precioActual = document.getElementById('ps-precio-actual');
  var precioAntes = document.getElementById('ps-precio-antes');
  var btnComprar = document.getElementById('ps-btn-comprar');
  var btnTexto = document.getElementById('ps-btn-comprar-texto');
  var filaPrecio = form.closest('.ps-prod-compra') ? form.closest('.ps-prod-compra').querySelector('.ps-prod-precio-fila') : null;
  var moneda = filaPrecio ? filaPrecio.getAttribute('data-ps-moneda') : 'EUR';
  var textoComprar = btnTexto ? btnTexto.getAttribute('data-ps-texto-comprar') || btnTexto.textContent : '';
  var textoAgotado = btnComprar ? btnComprar.getAttribute('data-ps-texto-agotado') || 'Agotado' : 'Agotado';

  function seleccionActual() {
    var seleccion = [];
    grupos.forEach(function (grupo) {
      var indice = parseInt(grupo.getAttribute('data-ps-opcion-index'), 10);
      var activo = grupo.querySelector('.is-activa');
      seleccion[indice] = activo ? activo.getAttribute('data-ps-valor') : null;
    });
    return seleccion;
  }

  function encontrarVariante(seleccion) {
    return variantes.find(function (v) {
      var opciones = [v.option1, v.option2, v.option3];
      return seleccion.every(function (val, i) { return val === undefined || val === null || opciones[i] === val; });
    });
  }

  function actualizarVariante() {
    var seleccion = seleccionActual();
    var variante = encontrarVariante(seleccion);
    if (!variante) return;

    if (inputId) inputId.value = variante.id;

    // Las tarjetas de pack traen los precios ya formateados por Shopify; si no, se formatean aquí.
    var activa = form.querySelector('.ps-prod-opcion-valor.is-activa');
    var hayOferta = variante.compare_at_price && variante.compare_at_price > variante.price;
    var textoPrecio = activa && activa.getAttribute('data-ps-precio') || formatearPrecio(variante.price, moneda);
    var textoAntes = hayOferta ? (activa && activa.getAttribute('data-ps-antes') || formatearPrecio(variante.compare_at_price, moneda)) : '';
    var textoDescuento = hayOferta ? (activa && activa.getAttribute('data-ps-descuento') || '-' + Math.floor((variante.compare_at_price - variante.price) * 100 / variante.compare_at_price) + '%') : '';

    function pintar(idPrecio, idAntes, idDescuento) {
      var p = document.getElementById(idPrecio);
      var a = document.getElementById(idAntes);
      var d = document.getElementById(idDescuento);
      if (p) p.textContent = textoPrecio;
      if (a) { a.textContent = textoAntes; a.hidden = !hayOferta; }
      if (d) { d.textContent = textoDescuento; d.hidden = !hayOferta; }
    }
    pintar('ps-precio-actual', 'ps-precio-antes', 'ps-descuento');
    // La barra de compra fija repite precio y botón: hay que mantenerla al día.
    pintar('ps-barra-precio', 'ps-barra-precio-antes', 'ps-barra-descuento');
    var pill = document.getElementById('ps-oferta-pill');
    if (pill) pill.hidden = !hayOferta;

    if (btnComprar) {
      btnComprar.disabled = !variante.available;
      if (btnTexto) btnTexto.textContent = variante.available ? textoComprar : textoAgotado;
    }

    var barraBoton = document.getElementById('ps-barra-btn');
    if (barraBoton) {
      barraBoton.disabled = !variante.available;
      barraBoton.textContent = variante.available ? textoComprar : textoAgotado;
    }

    if (variante.featured_image && variante.featured_image.position) {
      var indiceImagen = variante.featured_image.position - 1;
      var miniatura = document.querySelector('.ps-prod-miniatura[data-ps-miniatura-index="' + indiceImagen + '"]');
      if (miniatura) miniatura.click();
    }
  }

  grupos.forEach(function (grupo) {
    grupo.querySelectorAll('.ps-prod-opcion-valor').forEach(function (boton) {
      boton.addEventListener('click', function () {
        grupo.querySelectorAll('.ps-prod-opcion-valor').forEach(function (b) {
          b.classList.remove('is-activa');
          if (b.getAttribute('role') === 'radio') b.setAttribute('aria-checked', 'false');
        });
        boton.classList.add('is-activa');
        if (boton.getAttribute('role') === 'radio') boton.setAttribute('aria-checked', 'true');
        actualizarVariante();
      });
    });
  });
}

function initReveal() {
  var elementos = document.querySelectorAll('.ps-reveal');
  if (!elementos.length) return;
  if (!('IntersectionObserver' in window)) {
    elementos.forEach(function (el) { el.classList.add('ps-visible'); });
    return;
  }
  var observador = new IntersectionObserver(
    function (entradas) {
      entradas.forEach(function (entrada) {
        if (entrada.isIntersecting) {
          entrada.target.classList.add('ps-visible');
          observador.unobserve(entrada.target);
        }
      });
    },
    { threshold: 0.15, rootMargin: '0px 0px -40px 0px' }
  );
  elementos.forEach(function (el) { observador.observe(el); });
}

function initBarraFija() {
  var barra = document.querySelector('[data-ps-barra-fija]');
  var botonPrincipal = document.getElementById('ps-btn-comprar');
  if (!barra || !botonPrincipal || !('IntersectionObserver' in window)) return;

  var observador = new IntersectionObserver(
    function (entradas) {
      entradas.forEach(function (entrada) {
        // Solo cuando el botón principal ya ha quedado por encima de la pantalla.
        var yaPasado = !entrada.isIntersecting && entrada.boundingClientRect.top < 0;
        barra.classList.toggle('is-visible', yaPasado);
      });
    },
    { threshold: 0 }
  );

  observador.observe(botonPrincipal);
}

function initComparador() {
  var comparadores = document.querySelectorAll('[data-ps-comparador]');
  if (!comparadores.length) return;

  comparadores.forEach(function (comparador) {
    var rango = comparador.querySelector('.ps-ad-rango');
    var marco = comparador.querySelector('.ps-ad-marco');
    if (!rango || !marco) return;

    function actualizar() {
      marco.style.setProperty('--ps-pos', rango.value + '%');
    }

    function ponerDesdeX(clientX) {
      var caja = marco.getBoundingClientRect();
      var porcentaje = ((clientX - caja.left) / caja.width) * 100;
      rango.value = Math.round(Math.min(100, Math.max(0, porcentaje)));
      actualizar();
    }

    // Arrastre con ratón o dedo en cualquier punto de la imagen. En táctil se
    // espera a saber la dirección del gesto: horizontal mueve la barra y
    // vertical deja desplazar la página (touch-action: pan-y en el marco).
    var arrastrando = false;
    var decidido = false;
    var inicioX = 0;
    var inicioY = 0;

    marco.addEventListener('pointerdown', function (evento) {
      if (evento.pointerType === 'mouse' && evento.button !== 0) return;
      arrastrando = true;
      inicioX = evento.clientX;
      inicioY = evento.clientY;
      decidido = evento.pointerType === 'mouse';
      if (decidido) {
        evento.preventDefault();
        marco.setPointerCapture(evento.pointerId);
        ponerDesdeX(evento.clientX);
      }
    });

    marco.addEventListener('pointermove', function (evento) {
      if (!arrastrando) return;
      if (!decidido) {
        var dx = Math.abs(evento.clientX - inicioX);
        var dy = Math.abs(evento.clientY - inicioY);
        if (dx < 6 && dy < 6) return;
        if (dy > dx) {
          arrastrando = false;
          return;
        }
        decidido = true;
        try {
          marco.setPointerCapture(evento.pointerId);
        } catch (e) {}
      }
      ponerDesdeX(evento.clientX);
    });

    function soltar(evento) {
      // Un toque corto sin arrastrar también mueve la barra a ese punto.
      if (arrastrando && !decidido && evento.type === 'pointerup') ponerDesdeX(evento.clientX);
      arrastrando = false;
      decidido = false;
    }
    marco.addEventListener('pointerup', soltar);
    marco.addEventListener('pointercancel', soltar);

    rango.addEventListener('input', actualizar);
    actualizar();
  });
}

function initFlotante() {
  var elementos = document.querySelectorAll('[data-ps-flotante]');
  if (!elementos.length) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  if (window.matchMedia('(hover: none)').matches) return;

  var GIRO_MAX = 9;

  elementos.forEach(function (el) {
    el.addEventListener('mousemove', function (evento) {
      var caja = el.getBoundingClientRect();
      var x = (evento.clientX - caja.left) / caja.width - 0.5;
      var y = (evento.clientY - caja.top) / caja.height - 0.5;
      el.style.transition = 'transform 0.08s linear';
      el.style.setProperty('--ps-ry', (x * GIRO_MAX * 2).toFixed(2) + 'deg');
      el.style.setProperty('--ps-rx', (-y * GIRO_MAX * 2).toFixed(2) + 'deg');
    });

    el.addEventListener('mouseleave', function () {
      el.style.transition = '';
      el.style.setProperty('--ps-ry', '0deg');
      el.style.setProperty('--ps-rx', '0deg');
    });
  });
}

function initContador() {
  var contadores = document.querySelectorAll('[data-ps-contador]');
  if (!contadores.length) return;
  // El HTML ya trae el valor real. Solo se pone a 0 para animarlo si el
  // navegador puede hacerlo; los buscadores (Googlebot…) ven la cifra real.
  if (!('IntersectionObserver' in window)) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  if (/bot|crawl|spider|slurp|google-inspectiontool|lighthouse|headlesschrome/i.test(navigator.userAgent) || navigator.webdriver) return;
  contadores.forEach(function (el) {
    el.textContent = el.getAttribute('data-ps-decimales') === '1' ? (0).toFixed(1) : '0';
  });
  var observador = new IntersectionObserver(
    function (entradas) {
      entradas.forEach(function (entrada) {
        if (!entrada.isIntersecting) return;
        var el = entrada.target;
        observador.unobserve(el);
        var destino = parseFloat(el.getAttribute('data-ps-contador'));
        var decimales = el.getAttribute('data-ps-decimales') === '1';
        var duracion = 1400;
        var inicio = null;
        function paso(ts) {
          if (!inicio) inicio = ts;
          var progreso = Math.min((ts - inicio) / duracion, 1);
          var valor = destino * (1 - Math.pow(1 - progreso, 3));
          el.textContent = decimales ? valor.toFixed(1) : Math.round(valor);
          if (progreso < 1) window.requestAnimationFrame(paso);
        }
        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
          el.textContent = decimales ? destino.toFixed(1) : destino;
        } else {
          window.requestAnimationFrame(paso);
        }
      });
    },
    { threshold: 0.4 }
  );
  contadores.forEach(function (el) { observador.observe(el); });
}
